import React, { useMemo } from 'react';
import { CloseCircle } from '@myua/icons/dist/bulk16';
import * as sharingLinkActions from '../actions';
import { App, Button } from '@myua/kit';
import { useSelector, useDispatch } from 'react-redux';
import { getLinksById, getSelectedIds } from '../selectors';

export const DeleteButton = () => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(getSelectedIds);
  const linksById = useSelector(getLinksById);
  const { modal } = App.useApp();
  const disabled = useMemo(
    () => !selectedIds.length || selectedIds.some((id) => !linksById[id]?.is_active),
    [selectedIds, linksById],
  );

  return (
    <Button
      title="Deactivate selected"
      className="al-btn-blue-icon"
      disabled={disabled}
      onClick={() => {
        modal.confirm({
          content: `Links to be deactivated: ${selectedIds.length}`,
          onOk: (close) => {
            dispatch(sharingLinkActions.deleteClicked());
            close();
          },
          icon: null,
        });
      }}
      icon={<CloseCircle />}
    >
      Deactivate
    </Button>
  );
};
